module.exports = __webpack_public_path__ + "img/moon.52d8ea06.svg";